import { useCallback, useContext } from 'react'

import { UploadContext } from './context'

export function useUploadContext() {
  const ctx = useContext(UploadContext)
  if (!ctx) throw new Error('useUploadContext must be used within UploadProvider')
  return ctx
}

export function useImportRecordingsPicker() {
  const { startUploads } = useUploadContext()

  return useCallback(() => {
    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = true
    input.accept = '.mp3,.wav,.m4a,.ogg'
    input.onchange = (e) => {
      const files = Array.from((e.target as HTMLInputElement).files || [])
      if (files.length > 0) {
        startUploads(files)
      }
    }
    input.click()
  }, [startUploads])
}
